import { render, staticRenderFns } from "./RoomShow.vue?vue&type=template&id=1934105e&scoped=true&"
import script from "./RoomShow.vue?vue&type=script&lang=js&"
export * from "./RoomShow.vue?vue&type=script&lang=js&"
import style0 from "./RoomShow.vue?vue&type=style&index=0&id=1934105e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934105e",
  null
  
)

export default component.exports